import ModalForm from './ModalForm';

export default ModalForm;
